import Swiper, { Navigation } from 'swiper/core';

// configure Swiper to use modules
Swiper.use([Navigation]);

export default class SwiperCentered {
  constructor(swiperEl) {
    this.dom = {
      swiper: swiperEl,
    };

    this.data = {
      swiperConfig: {
        loop: true,
        slidesPerView: 'auto',
        loadPrevNextAmount: 3,
        initialSlide: Math.floor([...swiperEl.querySelectorAll('.swiper-slide')].length / 2),
        spaceBetween: 10,
        centeredSlides: true,
        freeMode: true,
        grabCursor: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          768: {
            spaceBetween: 20,
          },
          992: {
            spaceBetween: 30,
          },
          1200: {
            spaceBetween: 40,
          },
        },
      },
    };

    this.components = {
      swiperInstance: null,
    };

    this.mount();
  }

  mount() {
    this.components.swiperInstance = new Swiper(this.dom.swiper, this.data.swiperConfig);
  }
}
